import {
  Component,
  ViewEncapsulation,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  Renderer2,
  ChangeDetectorRef,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { DataTable } from "@bfx/primeng/datatable";

import { BfxBlotterFilterService } from "./bfx-blotter-filter.service";
import {
  BfxBlotterFilter,
  BfxBlotterFilterCondition,
  FilterType,
  BfxBlotterFilterId,
  ExtendedOrderTypeIdentifier,
} from "./bfx-blotter-filter.constants";
import { TranslateService } from "@ngx-translate/core";
import * as Constants from "./models/bfx-blotter-filter.constants";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterFilterSelectorService } from "./bfx-blotter-filter-selector.service";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { BfxPanelHelperService } from "../bfx-common/services/bfx-panel-helper.service";
import { BfxBlotterFilterSelectorComponent } from "../bfx-blotter-filter/bfx-blotter-filter-selector.component";
import { BFXBLOTTERFILTERCONDITIONLABELS } from "./models/bfx-blotter-filter.constants";

import {
  TableDefinition,
  ColumnFilterType,
  UserPromiseLookupService,
  AccountPromiseLookupService,
  ClientPromiseLookupService,
  TraderGroupPromiseLookupService,
  SalesGroupPromiseLookupService,
  CcyPromiseLookupService,
  CcyPairPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  BranchPromiseLookupService,
  FixingSourcePromiseLookupService,
  SysFeatures,
  ActiveUser,
  ActiveUserProfilePromiseService,
  FilterOrderTypes,
  BenchmarkFixingPrimaryLookupService,
  DIFilterReason,
} from "shared/cubiq-services";

import { CURRENCY_GROUP_VALUE_IDENTIFIER } from "../bfx-base-blotter/bfx-base-blotter-filtering.service";
import { MULTI_SELECTOR_LIMIT } from "../bfx-element-library/bfx-multi-selector.constants";

import {
  AutoCompleteLabelValue,
  SystemConfigPromiseService,
  AutoCompleteFilterOrderTypeLabelValue,
} from "shared/cubiq-services";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";

import { LoggerService } from "@bfx/logger";
import { DomHandler } from "@bfx/primeng/dom";
const logger = LoggerService.for(__dirname);

export const EXCLUDEDTENORS: Array<string> = ["EMPTY", "ALL"];

@Component({
  selector: ".bfx-blotter-filter-view",
  templateUrl: "./html/bfx-blotter-filter-view.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BfxBlotterFilterViewComponent implements OnInit, OnDestroy {
  @ViewChild("aCompDrDown", { static: true })
  private aCompDrDown: ElementRef;

  @Input()
  public blotterTypeId: BfxBlotterFilterId;

  @Input()
  public extendedTypeId: ExtendedOrderTypeIdentifier;

  public items: any[] = [];
  public emptyMessage: string;
  public tableDefinition: TableDefinition = null;
  public filterType: FilterType = null;

  public columns: any = {};

  public columnOptions: Array<any> = [];
  public columnSuggestions: Array<any> = [];
  public operatorSuggestions: Array<any> = [];
  public operatorAutoHighlightIndex: number = 0;
  public valueSuggestions: Array<any> = [];
  public objectSuggestions: Array<any> = [];
  public currencyPairGroupData: Array<any> = [];

  public primedData: any = {};

  public objectColumns: any = {};
  public booleanColumns: any = {};
  public validOperators: any = {};
  public columnFilterTypes: any = {};
  public saving: boolean = false;
  public blotterId: string = null;
  public showUserName: boolean;

  public objectValues: any = {};
  public objectValuesLookupFn: any = {};

  public _editedItem: BfxBlotterFilter;
  public _sliderValue: boolean = false;
  public dateValue: Date;
  public dateFromValue: Date;
  public dateToValue: Date;
  public saveAfterOr: false;
  public edit: boolean;
  public itemCounter: number = 0;

  public multipleOperators: any = {};
  public betweenOperators: any = {};
  public calendarPanelHelper: Element = null;
  public filterSelectionModes: Array<any> = Constants.FILTER_SELECTOR_MODES;
  public en: any;

  public minPercentageAway: BigNumber = new BigNumber(-999999999999999);

  protected editableColumnOperatorMap = new WeakMap();
  protected editableColumnCalendarMap = new WeakMap();

  static getBmarkTraderGroups(
    traderGroups: CubiqTS.TradingGroupImpl[],
  ): CubiqTS.TradingGroupImpl[] {
    return traderGroups.filter(
      (tradingGroup: CubiqTS.TradingGroupImpl) => tradingGroup.isBenchmarkFg,
    );
  }

  constructor(
    public blotterService: BfxBlotterFilterService,
    public translationService: TranslateService,
    public userService: UserPromiseLookupService,
    public accountService: AccountPromiseLookupService,
    public clientService: ClientPromiseLookupService,
    public traderGroupService: TraderGroupPromiseLookupService,
    public salesGroupService: SalesGroupPromiseLookupService,
    public branchLookupService: BranchPromiseLookupService,
    public ccyService: CcyPromiseLookupService,
    public ccyPairService: CcyPairPromiseLookupService,
    public currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
    private datePipe: DatePipe,
    private activeUserService: ActiveUserProfilePromiseService,
    private selectorService: BfxBlotterFilterSelectorService,
    private panelHelper: BfxPanelHelperService,
    public fixingSourceService: FixingSourcePromiseLookupService,
    public bmFixingSourceService: BenchmarkFixingPrimaryLookupService,
    public systemConfigLookup: SystemConfigPromiseService,
    public domHandler: DomHandler,
    renderer: Renderer2,
    public cd: ChangeDetectorRef,
  ) {
    this.editedItem = null;

    this.multipleOperators = this.blotterService.multipleOperators;
    this.betweenOperators = this.blotterService.betweenOperators;
    this.calendarPanelHelper = this.panelHelper.getPanel(
      "bfx-blotter__filter-manager__calendar_panel_helper",
      renderer,
    );
  }

  /**
   * Register the component on the blotter filter service with the given blotter type and asset class
   * announcing that this is currently the active filter view for the given filter type id.
   */
  ngOnInit() {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.blotterService.registerFilterView(
      this,
      this.blotterTypeId.blotterType,
      this.blotterTypeId.assetClass,
      this.extendedTypeId,
    );
    this.en = {
      firstDayOfWeek: 1,
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthNamesShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      today: "Today",
      clear: "Clear",
    };
  }

  ngOnDestroy(): void {
    this.panelHelper.destroy(this.calendarPanelHelper);
  }

  public initTableDefinition(
    tableDefinition: TableDefinition,
    filterType: FilterType,
    blotterId: string,
    extendedTypeId?: ExtendedOrderTypeIdentifier,
  ): void {
    this.tableDefinition = tableDefinition;
    this.filterType = filterType;
    this.blotterId = blotterId;
    this.extendedTypeId = extendedTypeId;

    this.objectValues = {};
    this.objectColumns = {};
    this.booleanColumns = {};
    this.validOperators = {};
    this.columnFilterTypes = {};
    this.columnOptions = [];
    this.columns = {};

    this.tableDefinition.columns.forEach((columnDef: BfxColDef) => {
      if (columnDef.columnFilterType != ColumnFilterType.NONE) {
        let label = columnDef.headerTooltip
          ? columnDef.headerTooltip.replace(/<.*?>/g, "").trim()
          : columnDef.headerName.replace(/<.*?>/g, "").trim();
        this.columns[columnDef.field] = columnDef;
        this.columnOptions.push({ label: label, value: columnDef.field });
        let columnKeys: any = {};
        let columnKey: string =
          columnDef.columnFilterType +
          "-" +
          (columnDef.columnFilterData && columnDef.columnFilterData["RemoteClass"]
            ? columnDef.columnFilterData.RemoteClass()
            : null);

        if (!columnKeys[columnKey]) {
          columnKeys[columnKey] = true;
          this.primeData(columnDef);
        }

        if (!this.validOperators[columnDef.field]) {
          this.validOperators[columnDef.field] = this.getValidOperators(columnDef);
        }

        this.objectColumns[columnDef.field] =
          Constants.OBJECT_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0 ||
          Constants.COMPOSITE_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0;
        this.booleanColumns[columnDef.field] =
          Constants.BOOLEAN_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0;
        this.columnFilterTypes[columnDef.field] = ColumnFilterType[columnDef.columnFilterType];
      }
    });
    this.columnOptions.sort(Constants.OBJECT_SORT);
  }

  public rowStyleClass(data: any): string {
    if (data.or) return "bfx-filter-or";
    return data && !(data.add || data.or) ? "editable" : "non-editable";
  }

  public get editedItem(): BfxBlotterFilter {
    return this._editedItem;
  }

  public set editedItem(editedItem: BfxBlotterFilter) {
    this._editedItem = editedItem;

    if (this._editedItem != null) {
      this.emptyMessage = this.translationService.instant("filter.manager.no.rules");
      this.blotterService
        .getTableDefinition(this._editedItem.filterIdentifier, this._editedItem.extendedTypeId)
        .then(
          (tableDef) => {
            this.tableDefinition = tableDef;
          },
          (rejection) => {
            logger.out.error(
              "ERROR:BfxBlotterFilterViewComponent editedItem rejection:",
              rejection,
            );
          },
        )
        .catch((reason) => {
          logger.out.error("ERROR:BfxBlotterFilterViewComponent editedItem reason: ", reason);
        });
    } else {
      this.emptyMessage = this.translationService.instant("filter.manager.no.filter.selected");
    }

    this.createDefaultEntry();
  }

  public createDefaultEntry(): void {
    if (
      this._editedItem != null &&
      this._editedItem["preload"] == null &&
      this._editedItem.conditions.length == 0
    ) {
      let defEntry: any = new BfxBlotterFilterCondition("", "", null, null, true);
      this._editedItem.conditions.push(defEntry);
      this.addCondition(defEntry);
    }
  }

  public getDataLabel(data, dateTo): string {
    if (
      data &&
      ((!this.blotterService.betweenOperators[data.operatorData.value] &&
        this.isValidDate(data.value)) ||
        (this.blotterService.betweenOperators[data.operatorData.value] &&
          !dateTo &&
          this.isValidDate(data.from)) ||
        (this.blotterService.betweenOperators[data.operatorData.value] &&
          dateTo &&
          this.isValidDate(data.to)))
    ) {
      let formatter: any = (value) => {
        return value ? value : "";
      };

      let columnDef: BfxColDef = this.columns[data.conditionData.value] as BfxColDef;
      if (columnDef.columnFilterType == ColumnFilterType.DATE) {
        formatter = (value) => {
          return this.datePipe.transform(value, "dd-MMM-yy");
        };
      } else if (columnDef.columnFilterType == ColumnFilterType.DATETIME) {
        formatter = (value) => {
          return this.datePipe.transform(value, "dd-MMM-yy HH:mm:ss");
        };
      } else if (columnDef.columnFilterType == ColumnFilterType.TIME) {
        formatter = (value) => {
          return this.datePipe.transform(value, "HH:mm:ss");
        };
      }
      // It's a between
      if (this.blotterService.betweenOperators[data.operatorData.value]) {
        if (dateTo === true) return formatter(data.to);
        return formatter(data.from);
      }

      return formatter(data.value);
    }

    return "";
  }

  private isValidDate(value: any): boolean {
    return (
      (value instanceof Date && !isNaN(value.getTime())) ||
      (typeof value === "number" && !isNaN(value)) ||
      (typeof value === "string" && !isNaN(parseInt(value)))
    );
  }

  public getPrimeDataKey(columnDef: BfxColDef): string {
    return (
      columnDef.columnFilterType +
      "-" +
      (columnDef.columnFilterData && columnDef.columnFilterData["RemoteClass"]
        ? columnDef.columnFilterData.RemoteClass()
        : null)
    );
  }

  public primeData(columnDef: BfxColDef): void {
    // FIXME this is running multiple times for same dataset
    if (columnDef && columnDef.columnFilterType == ColumnFilterType.ENUM) {
      let keys: string[] = Object.values(columnDef.columnFilterData).filter(
        (value) => typeof value === "string",
      ) as string[];
      if (columnDef.headerName == "Deal State") {
        // OMS-26189 - STP Cancelled should not be a deal state to filter
        let excludeSates = ["CANCELLED", "PENDING"];
        keys = keys.filter((elem) => !excludeSates.includes(elem));
      }
      if (columnDef.headerName == "Product") {
        this.blotterService
          .loadProductDataset(keys, true, this.tableDefinition.benchmarkTableDefinition)
          .then((res) => {
            keys = res;
            let values: any = keys.map((a) => {
              return {
                label: this.translationService.instant(
                  "column.filter." + columnDef.field + "." + a,
                ),
                value: a,
              };
            });
            let key: string = this.getPrimeDataKey(columnDef);
            this.primedData[key] = values.sort(Constants.OBJECT_SORT);
            this.objectValues[columnDef.field] = this.primedData[key];
          });
      } else {
        let values: any = keys.map((a) => {
          return {
            label: this.translationService.instant("column.filter." + columnDef.field + "." + a),
            value: a,
          };
        });
        let key: string = this.getPrimeDataKey(columnDef);
        this.primedData[key] = values.sort(Constants.OBJECT_SORT);
        this.objectValues[columnDef.field] = this.primedData[key];
      }
    } else if (columnDef.columnFilterType == ColumnFilterType.COMPOSITE_ENUM) {
      let keys: string[] = Object.keys(columnDef.columnFilterData);
      let length: number = keys.length - 2;
      keys = keys.splice(length / 2, length / 2);
      let values: any = keys.map((a) => {
        return {
          label: this.translationService.instant("column.filter." + columnDef.field + "." + a),
          value: a,
        };
      });
      let key: string = this.getPrimeDataKey(columnDef);
      this.primedData[key] = values.sort(Constants.OBJECT_SORT);
      this.objectValues[columnDef.field] = this.primedData[key];
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.ACCOUNT) {
      this.accountService.isPrimed().then(() => {
        this.accountService
          .getLabelValueByName({
            prefix: null,
            skip: 0,
            // limit: MULTI_SELECTOR_LIMIT, -> OMS-27050 - Should not limit primed data
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.accountService.getLabelValueByName.bind(
                this.accountService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.ACCOUNTID) {
      this.accountService.isPrimed().then(() => {
        this.accountService
          .getLabelValueById({
            prefix: null,
            skip: 0,
            // limit: MULTI_SELECTOR_LIMIT,  -> OMS-27050 - Should not limit primed data ???
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.accountService.getLabelValueById.bind(
                this.accountService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CLIENT) {
      this.clientService.isPrimed().then(() => {
        this.clientService
          .getLabelValueByName({
            prefix: null,
            skip: 0,
            // limit: MULTI_SELECTOR_LIMIT, // -> OMS-27050 - Should not limit primed data
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.clientService.getLabelValueByName.bind(
                this.clientService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CLIENTID) {
      this.clientService.isPrimed().then(() => {
        this.clientService
          .getLabelValueById({
            prefix: null,
            skip: 0,
            // limit: MULTI_SELECTOR_LIMIT, // -> OMS-27050 - Should not limit primed data
          })
          .then((primedData: AutoCompleteLabelValue[]) => {
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = primedData;
              this.objectValuesLookupFn[c.field] = this.clientService.getLabelValueById.bind(
                this.clientService,
              );
            });
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.BRANCH) {
      this.branchLookupService.isPrimed().then(() => {
        this.branchLookupService.getCompleteListOfBranchCodes().then((values: Array<string>) => {
          let key: string = this.getPrimeDataKey(columnDef);
          if (values) {
            this.primedData[key] = values
              .filter((a) => a != "System")
              .map((a) => {
                return { label: a, value: a };
              })
              .sort(Constants.OBJECT_SORT);
            this.primedData[key].unshift({
              label: "My Branch",
              value: "me()",
            });
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = this.primedData[key];
            });
          }
        });
      });
    } else if (
      columnDef &&
      columnDef.columnFilterType == ColumnFilterType.USER &&
      columnDef.columnFilterData != CubiqTS.UserType.CLIENT_TRADER
    ) {
      this.systemConfigLookup.getSystemConfig(SysFeatures.displayUserNames).then((cfg) => {
        this.showUserName =
          cfg == "true" || cfg == "TRUE" || cfg == "1" || cfg == "Y" || cfg == "y";

        this.userService.isPrimed().then(() => {
          this.userService.getAll().then((values: Array<CubiqTS.UserImpl>) => {
            this.activeUserService.getActiveUserData().then((activeUser: ActiveUser) => {
              let key: string = this.getPrimeDataKey(columnDef);
              if (values) {
                this.primedData[key] = values
                  .filter((a) => a.userType !== CubiqTS.UserType.CLIENT_TRADER)
                  .map((a) => {
                    return {
                      label: this.showUserName === true ? a.userName : a.userCode,
                      value: a.userCode,
                      type: a.userType,
                    };
                  })
                  .sort(Constants.OBJECT_SORT);

                this.primedData[key].unshift({
                  label: "Me",
                  value: "me()",
                  type: activeUser.userTypeId,
                });
                let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter((c) => {
                  return (
                    c.columnFilterType == columnDef.columnFilterType &&
                    c.columnFilterData != CubiqTS.UserType.CLIENT_TRADER
                  );
                });
                columnDefs.forEach((c) => {
                  this.objectValues[c.field] = this.primedData[key];
                });
              }
            });
          });
        });
      });
    } else if (
      columnDef &&
      columnDef.columnFilterType == ColumnFilterType.USER &&
      columnDef.columnFilterData == CubiqTS.UserType.CLIENT_TRADER
    ) {
      // FIXME this is running multiple times
      // TODO there appears to be filtering in the dropdown prime level filtering makes it a bit redundant
      this.userService.isPrimed().then(() => {
        this.userService.getAll().then((values: Array<CubiqTS.UserImpl>) => {
          this.activeUserService.getActiveUserData().then((activeUser: ActiveUser) => {
            let key: string = this.getPrimeDataKey(columnDef);
            if (values) {
              this.primedData[key] = values
                .filter((a) => a.userType === CubiqTS.UserType.CLIENT_TRADER)
                .map((a) => {
                  return {
                    label: a.userName,
                    value: a.userName,
                    type: a.userType,
                  };
                })
                .sort(Constants.OBJECT_SORT);

              this.primedData[key].unshift({
                label: "Me",
                value: "me()",
                type: activeUser.userTypeId,
              });
              let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter((c) => {
                return (
                  c.columnFilterType == columnDef.columnFilterType &&
                  c.columnFilterData == CubiqTS.UserType.CLIENT_TRADER
                );
              });
              columnDefs.forEach((c) => {
                this.objectValues[c.field] = this.primedData[key];
              });
            }
          });
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.TRADERGROUP) {
      this.traderGroupService.isPrimed().then(() => {
        this.traderGroupService.getAll().then((values: Array<CubiqTS.TradingGroupImpl>) => {
          let key: string = this.getPrimeDataKey(columnDef);
          if (values) {
            if (!this.isInterventionFilterManager()) {
              values = this.isBenchmarkFilterManager()
                ? BfxBlotterFilterViewComponent.getBmarkTraderGroups(values)
                : this.getLimitsTraderGroups(values);
            }
            this.primedData[key] = values
              .map((a) => {
                return { label: a.groupCode, value: a.groupId };
              })
              .sort(Constants.OBJECT_SORT);
            this.primedData[key].unshift({
              label: "My Trader Groups",
              value: "me()",
            });
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = this.primedData[key];
            });
          }
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.SALESGROUP) {
      this.salesGroupService.isPrimed().then(() => {
        this.salesGroupService.getAll().then((values: Array<CubiqTS.SalesGroupImpl>) => {
          let key: string = this.getPrimeDataKey(columnDef);
          if (values) {
            this.primedData[key] = values
              .map((a) => {
                return { label: a.groupCode, value: a.groupId };
              })
              .sort(Constants.OBJECT_SORT);
            this.primedData[key].unshift({
              label: "My Sales Groups",
              value: "me()",
            });
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = this.primedData[key];
            });
          }
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CURRENCY) {
      this.ccyService.isPrimed().then(() => {
        this.ccyService.getAll().then((values: Array<CubiqTS.CurrencyImpl>) => {
          let key: string = this.getPrimeDataKey(columnDef);
          if (values) {
            this.primedData[key] = values
              .map((a) => {
                return { label: a.id, value: a.id };
              })
              .sort(Constants.OBJECT_SORT);
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = this.primedData[key];
            });
          }
        });
      });
    } else if (
      (columnDef && columnDef.columnFilterType == ColumnFilterType.CURRENCY_PAIR) ||
      columnDef.columnFilterType == ColumnFilterType.CURRENCY_PAIR_GROUP
    ) {
      this.ccyPairService.isPrimed().then(() => {
        this.ccyPairService.getAll().then((values: Array<CubiqTS.CurrencyPairImpl>) => {
          if (values) {
            let currencies: any = {};
            let currencyPairs: Array<string> = values.map((a) => {
              currencies[a.base] = currencies[a.nonBase] = true;
              return a.base + "/" + a.nonBase;
            });
            Object.keys(currencies).forEach((c) => currencyPairs.push(c + "/***"));
            let key: string = this.getPrimeDataKey(columnDef);
            this.primedData[key] = currencyPairs.sort().map((a) => {
              return { label: a, value: a };
            });
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = this.primedData[key];
            });
          }
        });
      });

      this.ccyPairService.isPrimed().then(() => {
        this.currencyPairGroupService
          .getAll()
          .then((values: Array<CubiqTS.CurrencyPairGroupImpl>) => {
            if (values) {
              this.currencyPairGroupData = values
                .map((a) => {
                  return {
                    label: a.currencypairGroupNm,
                    value: a.id.toNumber(),
                  };
                })
                .sort(Constants.OBJECT_SORT);
              this.blotterService.currencyPairGroupData = this.currencyPairGroupData;
            }
          });
      });
    } else if (
      columnDef &&
      (columnDef.columnFilterType == ColumnFilterType.ORDERSTATE ||
        columnDef.columnFilterType == ColumnFilterType.AUTO_ELIGIBLE)
    ) {
      let keys: string[] = Object.keys(columnDef.columnFilterData);
      keys = this.cleanEnumKeys(keys);
      let values: any =
        columnDef.columnFilterType == ColumnFilterType.AUTO_ELIGIBLE
          ? keys.map((a) => {
              return { label: a.toString(), value: a };
            })
          : keys.map((a) => {
              return {
                label: this.translationService.instant(
                  "column.filter." + columnDef.field + "." + a,
                ),
                value: a,
              };
            });
      let key: string = this.getPrimeDataKey(columnDef);
      if (values) {
        this.primedData[key] = values.sort(Constants.OBJECT_SORT);
        this.objectValues[columnDef.field] = this.primedData[key];
      }
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.ORDERTYPE) {
      let keys: any[] = Object.keys(columnDef.columnFilterData);
      keys = this.cleanEnumKeys(keys);

      let algosOnly: boolean =
        this.blotterTypeId.blotterType === CubiqTS.BlotterType.ORDER &&
        this.extendedTypeId === ExtendedOrderTypeIdentifier.ALGO;
      let loadBmarkOrders: boolean =
        this.tableDefinition.benchmarkTableDefinition ||
        this.tableDefinition.riskTradeTableDefinition ||
        this.tableDefinition.clientTradeTableDefinition;
      let benchmarkOnly: boolean = this.tableDefinition.benchmarkTableDefinition;

      this.blotterService
        .loadOrderTypeDataset(keys, loadBmarkOrders, benchmarkOnly, algosOnly)
        .then((res) => {
          keys = res;
          let values: any = keys.map((a: string | AutoCompleteFilterOrderTypeLabelValue) => {
            if (a instanceof AutoCompleteFilterOrderTypeLabelValue) {
              return a;
            }
            return new AutoCompleteFilterOrderTypeLabelValue(
              FilterOrderTypes[a],
              this.translationService.instant("column.filter." + columnDef.field + "." + a),
              a,
            );
          });
          let key: string = this.getPrimeDataKey(columnDef);
          if (values) {
            this.primedData[key] = values.sort(Constants.OBJECT_SORT);
            this.objectValues[columnDef.field] = this.primedData[key];
          }
        });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.CHANNEL) {
      this.clientService.isPrimed().then(() => {
        this.clientService
          .getTradingChannels()
          .then((values: Array<CubiqTS.TradingChannelProfileImpl>) => {
            let key: string = this.getPrimeDataKey(columnDef);
            if (values) {
              this.primedData[key] = values
                .map((a: CubiqTS.TradingChannelProfileImpl) => {
                  return {
                    label: a.tradingSourceDisplayName,
                    value: a.channelId,
                  };
                })
                .sort(Constants.OBJECT_SORT);
              let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
                (c) => c.columnFilterType == columnDef.columnFilterType,
              );
              columnDefs.forEach((c) => {
                this.objectValues[c.field] = this.primedData[key];
              });
            }
          });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.FIXCODE) {
      this.fixingSourceService.isPrimed().then(() => {
        this.fixingSourceService.getAll().then((values: Array<CubiqTS.NdfSourceImpl>) => {
          let key: string = this.getPrimeDataKey(columnDef);
          if (values) {
            this.primedData[key] = values
              .map((a: CubiqTS.NdfSourceImpl) => {
                return {
                  label: `(${a.ccyPair}) ${a.fixingCode}`,
                  value: a.fixingCode,
                };
              })
              .sort(Constants.OBJECT_SORT);
            this.primedData[key].push({
              label: this.translationService.instant("fixingSource.custom").toUpperCase(),
              value: this.translationService.instant("fixingSource.custom"),
            });
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c) => c.columnFilterType == columnDef.columnFilterType,
            );
            columnDefs.forEach((c) => {
              this.objectValues[c.field] = this.primedData[key];
            });
          }
        });
      });
    } else if (columnDef && columnDef.columnFilterType === ColumnFilterType.BM_FIXCODE) {
      this.bmFixingSourceService.isPrimed().then(() => {
        this.bmFixingSourceService.getAll().then((values: Array<CubiqTS.BenchmarkFixingImpl>) => {
          let key: string = this.getPrimeDataKey(columnDef);
          if (values) {
            this.primedData[key] = values
              .map((a: CubiqTS.BenchmarkFixingImpl) => {
                return {
                  label: a.benchmarkCd,
                  value: a.benchmarkCd,
                };
              })
              .sort(Constants.OBJECT_SORT);
            let columnDefs: Array<BfxColDef> = this.tableDefinition.columns.filter(
              (c: BfxColDef) => c.columnFilterType === columnDef.columnFilterType,
            );
            columnDefs.forEach(
              (c: BfxColDef) => (this.objectValues[c.field] = this.primedData[key]),
            );
          }
        });
      });
    } else if (columnDef && columnDef.columnFilterType == ColumnFilterType.DATE_TENOR) {
      let keys: string[] = Object.keys(columnDef.columnFilterData);
      keys = keys.splice((keys.length - 2) / 2, (keys.length - 2) / 2);
      let values: any = keys
        .filter((val: string) => EXCLUDEDTENORS.indexOf(val) == -1)
        .map((a) => {
          return {
            label: this.translationService.instant("column.filter." + columnDef.field + "." + a),
            value: CubiqTS.Tenor[a],
          };
        });
      let key: string = this.getPrimeDataKey(columnDef);
      this.primedData[key] = this.objectValues[columnDef.field] = values;
    }
  }

  private cleanEnumKeys(keys): string[] {
    return keys.splice(keys.length / 2, keys.length / 2);
  }

  public addCondition(item: BfxBlotterFilterCondition): void {
    let index: number = this._editedItem.conditions.indexOf(item);
    let columnOptions: Array<any> = this.getColumnOptions(item);
    columnOptions =
      columnOptions == null || columnOptions.length < 1 ? this.columnOptions : columnOptions;
    let defColumn: BfxColDef = this.columns[columnOptions[0].value];
    let operator: CubiqTS.Operator = this.validOperators[defColumn.field];
    let entry: any = new BfxBlotterFilterCondition(
      defColumn.field,
      defColumn.headerName,
      operator[0].value,
      null,
    );
    this._editedItem.conditions.splice(index, 0, entry);

    this._editedItem.conditions.forEach((condition) => {
      let index: number = this._editedItem.conditions.indexOf(condition);
      if (this._editedItem.conditions[index + 1] != undefined) {
        if (
          condition.iconDisabled === true &&
          this._editedItem.conditions[index + 1].add === false &&
          !condition.add
        )
          condition.iconDisabled = false;
      }
    });

    if (columnOptions.length == 1) this._editedItem.conditions[index + 1].iconDisabled = true;
  }

  public removeCondition(item: BfxBlotterFilterCondition): void {
    let index: number = this._editedItem.conditions.indexOf(item);
    if (
      (index == 0 && this._editedItem.conditions[index + 1].add) ||
      (index > 0 &&
        this._editedItem.conditions[index - 1].or &&
        this._editedItem.conditions[index + 1].add)
    )
      return;
    this._editedItem.conditions.splice(index, 1);
    if (this._editedItem.conditions[this._editedItem.conditions.length - 1].iconDisabled)
      this._editedItem.conditions[this._editedItem.conditions.length - 1].iconDisabled = false;

    for (let j = index; j < this._editedItem.conditions.length; j++) {
      if (
        this._editedItem.conditions[j].iconDisabled == true &&
        this._editedItem.conditions[j].add
      ) {
        this._editedItem.conditions[j].iconDisabled == false;
        break;
      }
    }
    // Check for empty Or segments
    let orIndex: number = -1;
    for (let i: number = 1; i < this._editedItem.conditions.length; i++) {
      let row: BfxBlotterFilterCondition = this._editedItem.conditions[i];
      if (row.or) {
        if (i - 2 == orIndex) {
          this._editedItem.conditions.splice(orIndex, 2);
          i -= 2;
        } else {
          orIndex = i;
        }
      }
    }
  }

  public removeOr(item: BfxBlotterFilterCondition): void {
    if (!this.edit) return;
    let index: number = this._editedItem.conditions.indexOf(item);
    let spliceIndex: number = 1;
    for (let i = index + 1; i < this._editedItem.conditions.length; i++) {
      if (this._editedItem.conditions[i].or) break;
      spliceIndex++;
    }
    this._editedItem.conditions.splice(index, spliceIndex);
  }

  public selectOption(data: any, event: any) {
    if (event.alternativeActive != null) {
      if (event.alternativeActive) {
        data.altValue = event.selectedOptions;
      } else {
        data.value = event.selectedOptions;
      }
    } else {
      data.value = event;
    }
  }

  public selectFromOption(data: any, event: any) {
    if (event != null && Array.isArray(event.selectedOptions)) {
      data.from = event.selectedOptions[0];
    }
  }

  public selectToOption(data: any, event: any) {
    if (event != null && Array.isArray(event.selectedOptions)) {
      data.to = event.selectedOptions[0];
    }
  }

  public selectAltOption(data: any, event: any) {
    if (event.alternativeActive != null) {
      if (event.alternativeActive) {
        data.value = event.altSelectedOptions;
      } else {
        data.altValue = event.altSelectedOptions;
      }
    } else {
      data.altValue = event;
    }
  }

  public appendOr(): void {
    let size: number = this._editedItem.conditions.length;
    if (size > 1 && !this._editedItem.conditions[size - 2].or) {
      this._editedItem.conditions.push(
        new BfxBlotterFilterCondition("", "", null, null, false, true),
      );
      let defEntry: any = new BfxBlotterFilterCondition("", "", null, null, true);
      this._editedItem.conditions.push(defEntry);
      this.addCondition(defEntry);
    }
  }

  public orDisabled(): boolean {
    if (this._editedItem == null || this._editedItem.conditions.length < 2) {
      return false;
    }

    let orCount: number = 0;
    this._editedItem.conditions.forEach((a) => (orCount += a.or ? 1 : 0));
    return orCount >= Constants.OR_CONDITION_LIMIT;
  }

  public saveDisabled(): boolean {
    let save: boolean = this._editedItem.conditions.length > 0;

    for (let i: number = 0; i < this._editedItem.conditions.length; i++) {
      let condition: BfxBlotterFilterCondition = this._editedItem.conditions[i];
      save = save && (condition.or || condition.add || condition.value);
    }

    return save;
  }

  public getColumnOptions(data: any): Array<any> {
    let index: number = this._editedItem.conditions.indexOf(data);

    let conditionQuery: string = null;
    if (data.conditionData.value === undefined) {
      conditionQuery = data.conditionData;
      data.conditionData = { label: data.fieldTitle, value: data.fieldName };
    }

    let startIndex: number = 0;
    for (let i: number = index; i >= 0 && startIndex == 0; i--) {
      if (this._editedItem.conditions[i].or) {
        startIndex = i + 1;
      }
    }

    let endIndex: number = this.editedItem.conditions.length;
    for (let i: number = index; i < this._editedItem.conditions.length; i++) {
      if (this._editedItem.conditions[i].or) {
        endIndex = i;
      }
    }

    let group: Array<BfxBlotterFilterCondition> = this._editedItem.conditions.slice(
      startIndex,
      endIndex,
    );
    let groupFields: Array<string> = group.map(
      (condition: BfxBlotterFilterCondition) => condition.conditionData.value,
    );
    let options: Array<any> = this.columnOptions.filter(
      (option: any) => groupFields.indexOf(option.value) < 0,
    );

    options.push(data.conditionData);

    if (data.conditionData.label == null) {
      data.conditionData.label = "";
    }

    options.sort(Constants.OBJECT_SORT);

    if (options[0].value == null || options[0].value == "") {
      options.splice(0, 1);
    }

    if (conditionQuery != null) {
      data.conditionData = conditionQuery;
    }

    return options;
  }

  public searchColumn(event: any, data: any): void {
    let query: string = event.query.toLowerCase();
    this.columnSuggestions = this.getColumnOptions(data).filter(
      (a) => a.label.toLowerCase().indexOf(query) >= 0,
    );
  }

  public showColumnOptions(event: any, data: any): void {
    this.columnSuggestions = this.getColumnOptions(data);
  }

  public searchOperator(event: any, data: any): void {
    if (data.conditionData.value === undefined) {
      return;
    }
    const fullMatchSuggestions = new Set();
    const weakMatchSuggestions = new Set();
    let fullIndex = -1;
    let weakIndex = -1;
    let query: string = event.query == " " ? "" : event.query.toLowerCase();
    let columnDef: BfxColDef = this.columns[data.conditionData.value] as BfxColDef;
    this.validOperators[columnDef.field].forEach((operator) => {
      let existing = data.operatorData.value;
      let isMatchExisting = existing == operator.value;

      if (operator.label.toLowerCase() === query) {
        fullMatchSuggestions.add(operator);
        if (isMatchExisting) {
          fullIndex = fullMatchSuggestions.size;
        }
      } else if (operator.label.toLowerCase().indexOf(query) >= 0) {
        if (isMatchExisting) {
          weakIndex = weakMatchSuggestions.size;
        }
        weakMatchSuggestions.add(operator);
      }
    });

    this.operatorSuggestions = [...fullMatchSuggestions, ...weakMatchSuggestions];
    if (fullIndex >= 0) {
      this.operatorAutoHighlightIndex = fullIndex;
    } else if (weakIndex >= 0) {
      this.operatorAutoHighlightIndex = fullMatchSuggestions.size + weakIndex;
    } else {
      this.operatorAutoHighlightIndex = 0;
    }
  }

  public showOperatorOptions(event: any, data: any): void {
    if (data.conditionData.value === undefined) {
      this.operatorSuggestions = [];
      return;
    }
    let columnDef: BfxColDef = this.columns[data.conditionData.value] as BfxColDef;
    let suggest: any = this.validOperators[columnDef.field];

    this.operatorSuggestions = [];
    for (let i = 0; i < suggest.length; i++) {
      const operator = suggest[i];
      if (data.operatorData && data.operatorData.value == operator.value) {
        this.operatorAutoHighlightIndex = i;
      }
      this.operatorSuggestions.push(operator);
    }
  }

  public searchValue(event: any, data: any): void {
    let query: string = event.query.toLowerCase();

    this.objectSuggestions = this.getObjectValues(data).filter(
      (a) => a.label.toLowerCase().indexOf(query) >= 0,
    );
  }

  public showValueOptions(event: any, data: any): void {
    this.operatorSuggestions = [];
    this.objectSuggestions = this.getObjectValues(data);
  }

  private getObjectValues(data: any): Array<any> {
    // For performance reasons don't use from template or filter dyanmically
    let values: Array<any> = this.objectValues[data.conditionData.value];
    return values;
  }

  public getValidOperators(columnDef: BfxColDef): Array<any> {
    if (Constants.OBJECT_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
      if (columnDef.columnFilterType == ColumnFilterType.DATE_TENOR) {
        return BFXBLOTTERFILTERCONDITIONLABELS.filter(
          (a) => Constants.VALUE_DATE_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
        );
      }
      return BFXBLOTTERFILTERCONDITIONLABELS.filter(
        (a) => Constants.OBJECT_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
      );
    } else if (Constants.NUMBER_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
      return BFXBLOTTERFILTERCONDITIONLABELS.filter(
        (a) => Constants.NUMBER_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
      );
    } else if (Constants.COMPOSITE_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
      return BFXBLOTTERFILTERCONDITIONLABELS.filter(
        (a) => Constants.OBJECT_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
      );
    } else if (Constants.DATE_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
      return BFXBLOTTERFILTERCONDITIONLABELS.filter(
        (a) => Constants.DATE_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
      );
    } else if (Constants.BOOLEAN_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
      return BFXBLOTTERFILTERCONDITIONLABELS.filter(
        (a) => Constants.BOOLEAN_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
      );
    } else if (Constants.STRING_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
      if (columnDef.field == "comments1" || columnDef.field == "comments2")
        return BFXBLOTTERFILTERCONDITIONLABELS.filter(
          (a) => Constants.COMMENTS_STRING_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
        );
      return BFXBLOTTERFILTERCONDITIONLABELS.filter(
        (a) => Constants.STRING_COLUMN_FILTER_OPS.indexOf(a.value) >= 0,
      );
    }
  }

  public onSelectCondition(data: BfxBlotterFilterCondition): void {
    if (data.prevCondition != data.conditionData.value) {
      let columnDef: BfxColDef = this.columns[data.conditionData.value] as BfxColDef;
      let suggestions: Array<any> = this.validOperators[columnDef.field];
      let suggestionNames: Array<string> = suggestions.map((a) => a.label);

      if (suggestionNames.indexOf(data.operatorData.label) < 0) {
        data.operatorData = suggestions[0];
      }

      data.value = data["from"] = data["to"] = null;
      data.fieldTitle = data.conditionData.label;
      data.prevCondition = data.fieldName = data.conditionData.value;
    }
  }

  public onSelectOperator(data: BfxBlotterFilterCondition): void {
    if (data.prevOperator != data.operatorData.value) {
      let columnDef: BfxColDef = this.columns[data.conditionData.value] as BfxColDef;
      let suggestions: Array<any> = this.validOperators[columnDef.field];
      let suggestionNames: Array<string> = suggestions.map((a) => a.label);

      if (suggestionNames.indexOf(data.operatorData.label) < 0) {
        data.operatorData = suggestions[0];
      }

      if (
        this.blotterService.betweenOperators[data.prevOperator] !=
        this.blotterService.betweenOperators[data.operatorData.value]
      ) {
        data.value = data["from"] = data["to"] = null;
      }

      data.prevOperator = data.operatorData.value;
    }
  }

  public shouldSave(): boolean {
    if (this._editedItem == null || this._editedItem.conditions.length == 0) {
      return false;
    }

    let count: number = 0;
    for (let i: number = 0; i < this._editedItem.conditions.length; i++) {
      let condition: BfxBlotterFilterCondition = this._editedItem.conditions[i];
      if (!condition.add && !condition.or) {
        count++;
        if (condition.value == null && (condition["from"] == null || condition["to"] == null)) {
          return false;
        }

        if (
          condition.value != null &&
          condition.value.length <= 0 &&
          condition.altValue != null &&
          condition.altValue.length <= 0
        )
          return false;

        let operatorValidator: any = this.validOperators[condition.conditionData.value];
        if (operatorValidator == null) {
          return false;
        }

        let operatorValidatorFiltered: any = operatorValidator.filter(
          (c) => c.label == condition.operatorData.label,
        );
        if (
          this.validOperators[condition.conditionData.value].filter(
            (c) => c.label == condition.operatorData.label,
          ).length <= 0
        )
          return false;

        if (
          condition.conditionData.length ||
          condition.conditionData.length <= 0 ||
          condition.operatorData.length <= 0
        )
          return false;
      }
    }

    return count > 0;
  }

  public createQueryGroup(filter: BfxBlotterFilter): CubiqTS.QueryGroupImpl {
    let outterGroup: CubiqTS.QueryGroupImpl = new CubiqTS.QueryGroupImpl();
    let innerGroup: CubiqTS.QueryGroupImpl = new CubiqTS.QueryGroupImpl();

    outterGroup.condition = CubiqTS.Condition.OR;
    outterGroup.groups = [];

    for (let i: number = 0; i < filter.conditions.length; i++) {
      let condition: BfxBlotterFilterCondition = filter.conditions[i];

      if (condition.or || outterGroup.groups.length == 0) {
        innerGroup = new CubiqTS.QueryGroupImpl();
        innerGroup.condition = CubiqTS.Condition.AND;
        outterGroup.groups.push(innerGroup);
        innerGroup.rules = [];
      }

      if (!condition.add && !condition.or) {
        let rule: CubiqTS.QueryRuleImpl = new CubiqTS.QueryRuleImpl();
        rule.operator = condition.operatorData.value;
        rule.field = condition.conditionData.value;
        let columnDef: BfxColDef = this.columns[condition.conditionData.value] as BfxColDef;

        let values: Array<any> = [];
        if (this.blotterService.betweenOperators[condition.operatorData.value]) {
          values = [condition["from"], condition["to"]];
        } else if (
          Constants.OBJECT_COLUMN_FILTER_OPS.indexOf(condition.operatorData.value) < 0 &&
          columnDef.columnFilterType !== ColumnFilterType.DATE_TENOR
        ) {
          values = [condition.value];
        } else {
          values = condition.value;
        }

        if (Constants.DATE_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          values = values.map((r) => r + "");
        } else if (Constants.NUMBER_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          values = values.map((r) => r + "");
        } else if (
          columnDef.columnFilterType == Constants.OBJECT_CURRENCY_PAIR_GROUP_COLUMN_FILTER_TYPE
        ) {
          let ccyPairs = Array.isArray(condition.value) ? condition.value.map((p) => p.value) : [];
          let ccyPairGroups = Array.isArray(condition.altValue)
            ? condition.altValue.map((p) => p.value.toString())
            : [];

          values = [
            CURRENCY_GROUP_VALUE_IDENTIFIER,
            ...ccyPairGroups,
            CURRENCY_GROUP_VALUE_IDENTIFIER,
            ...ccyPairs,
          ];
        } else if (Constants.OBJECT_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          values = values.map((r) => r.value + "");
        } else if (
          Constants.COMPOSITE_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0
        ) {
          values = values
            .map((rules) => DIFilterReason.getFilterValue(rules.value))
            // flatten the returned arrays from getFilterValue
            .reduce((acc, val) => acc.concat(val), []);
        } else if (Constants.BOOLEAN_COLUMN_FILTER_TYPES.indexOf(columnDef.columnFilterType) >= 0) {
          values = values.map((r) => r);
        }

        rule.values = values;

        innerGroup.rules.push(rule);
      }
    }

    for (let i: number = 0; i < outterGroup.groups.length; i++) {
      let group: CubiqTS.QueryGroupImpl = outterGroup.groups[i];
      if (group.rules.length == 0) {
        outterGroup.groups.splice(i, 1);
      }
    }

    if (outterGroup.groups.length == 1) {
      outterGroup = innerGroup;
    }

    return outterGroup;
  }

  public save(): void {
    this.saving = true;
    //
    this.processConditionDatesToUnixTimestamp(this._editedItem);
    // Create query group
    let queryGroup: CubiqTS.QueryGroupImpl = this.createQueryGroup(this._editedItem);
    this.blotterService
      .saveFilter(this.filterType, this._editedItem, queryGroup)
      .then((response) => {
        this.saving = false;
        this.edit = false;
        this.blotterService.setIsEditableMode(false);
      })
      .catch((err) => {
        let blotterTypeId: BfxBlotterFilterId = this.blotterTypeId;
        logger.out.error(
          this.translationService.instant("error.save.filter"),
          blotterTypeId.blotterType,
          blotterTypeId.assetClass,
        );
        this.saving = false;
      });
  }

  private processConditionDatesToUnixTimestamp(blotterFilter: BfxBlotterFilter): void {
    if (
      blotterFilter instanceof BfxBlotterFilter &&
      Array.isArray(blotterFilter.conditions) &&
      blotterFilter.conditions.length > 0
    ) {
      for (let condition of blotterFilter.conditions) {
        if (condition instanceof BfxBlotterFilterCondition) {
          let columnDef: BfxColDef = this.columns[condition.conditionData.value] as BfxColDef;
          if (columnDef != null && columnDef.columnFilterType == ColumnFilterType.DATE) {
            // value
            if (
              condition.value instanceof Date ||
              (typeof condition.value === "string" && isNaN(parseInt(condition.value)))
            ) {
              this.processCalendarValue(condition.value, condition);
            }
            // to
            if (
              condition.to instanceof Date ||
              (typeof condition.to === "string" && isNaN(parseInt(condition.to)))
            ) {
              this.processCalendarValue(condition.to, condition, true);
            }
            //from
            if (
              condition.from instanceof Date ||
              (typeof condition.from === "string" && isNaN(parseInt(condition.from)))
            ) {
              this.processCalendarValue(condition.from, condition);
            }
          }
        }
      }
    }
  }

  public parseSwitchValue(value: any): number {
    return value === "true" ? 1 : 0;
  }

  public addOrRemoveCondition(data: any): void {
    if (!this.edit) return;
    data.add ? this.addCondition(data) : this.removeCondition(data);
  }

  public displayDropDown(event: any): void {
    this.selectorService.passKeyDownEven(event);
  }

  public focusTriggered(event, ref, isFocused) {
    if (isFocused && ref instanceof BfxBlotterFilterSelectorComponent) {
      let selector = ref as BfxBlotterFilterSelectorComponent;
      selector.showOptionsOnClick();
      selector.hasFocus = isFocused;
    }
  }

  public onKeydown(event, data) {
    switch (event.which) {
      case 13:
        if (data && !data.or) {
          this.addOrRemoveCondition(data);
        } else if (data && data.or) {
          this.removeOr(data);
        }
        event.preventDefault();
        break;
    }
  }

  public parseConditions(conditions) {
    conditions.forEach((condition: BfxBlotterFilterCondition) => {
      let index: number = conditions.indexOf(condition);

      // Make sure operator data is not null
      if (condition && condition.operatorData == null) {
        condition.operatorData = {};
      }

      if (
        (index == 0 && conditions[index + 1] && conditions[index + 1].add) ||
        (index > 0 &&
          conditions[index - 1] &&
          conditions[index - 1].or &&
          conditions[index + 1] &&
          conditions[index + 1].add)
      )
        condition.iconDisabled = true;
      if (
        this.columnFilterTypes[condition.conditionData.value] == "NUMBER" ||
        this.columnFilterTypes[condition.conditionData.value] == "INT" ||
        this.columnFilterTypes[condition.conditionData.value] == "PERCENTAGE"
      ) {
        // if(condition.conditionData.label == '% Away') {
        //     condition.conditionData.label = '% Away';
        // }

        if (!this.betweenOperators[condition.operatorData.value]) {
          if (typeof condition.value === "number" || typeof condition.value === "string") {
            condition.value = new BigNumber(condition.value);
          }

          if (
            this.columnFilterTypes[condition.conditionData.value] == "PERCENTAGE" &&
            condition.value == null
          ) {
            condition.value = new BigNumber("0");
          }
        } else {
          if (typeof condition["from"] === "number" || typeof condition["from"] === "string") {
            condition["from"] = new BigNumber(condition["from"]);
          }
          if (typeof condition["to"] === "number" || typeof condition["to"] === "string") {
            condition["to"] = new BigNumber(condition["to"]);
          }
          if (
            this.columnFilterTypes[condition.conditionData.value] == "PERCENTAGE" &&
            condition["from"] == null
          ) {
            condition["from"] = new BigNumber("0");
          }
          if (
            this.columnFilterTypes[condition.conditionData.value] == "PERCENTAGE" &&
            condition["to"] == null
          ) {
            condition["to"] = new BigNumber("0");
          }
        }
      }
    });
    return conditions;
  }

  public cancelFilterEditing() {
    this.edit = false;
    this.editedItem = null;
    this.blotterService.setIsEditableMode(false);
  }

  public proxyOnTabSelector(data, dt, rowIndex) {
    const proxyTarget = this;
    data.proxyTabSelector = function proxiedOnTabValueFn() {
      const args = Array.from(arguments);
      //console.assert(args.length === 1, `onTabValue proxy call has invalid argument length ${args.length}`);
      args.push(data, dt, rowIndex);
      proxyTarget.onTabSelector.apply(proxyTarget, args);
    };
    return data.proxyTabSelector;
  }

  public onTabSelector(event, data: BfxBlotterFilterCondition, dt: DataTable, rowIndex: number) {
    let passthrough = false;
    dt.closeCell();

    if (event.shiftKey) {
      setTimeout(() => {
        let targetCell = this.editableColumnOperatorMap.get(data);
        targetCell.focusInput();
      }, 4);
    } else {
      passthrough = true;
    }

    if (!passthrough) event.preventDefault();
  }

  public focusEditableOperator(operator, data): any {
    this.editableColumnOperatorMap.set(data, operator);
  }

  public focusEditableAttribute(attribute: any): any {
    attribute.focusInput();
  }

  public getSelectedOptions(data: any, options: string) {
    switch (options) {
      case "value":
        return data.value;
      case "to":
        return [data.to];
      case "from":
        return [data.from];
    }
    return "";
  }

  public getLimitsTraderGroups(
    traderGroups: CubiqTS.TradingGroupImpl[],
  ): CubiqTS.TradingGroupImpl[] {
    let benchmarkTraderGroupList = BfxBlotterFilterViewComponent.getBmarkTraderGroups(traderGroups);
    return traderGroups.filter(
      (tradingGroup: CubiqTS.TradingGroupImpl) => !benchmarkTraderGroupList.includes(tradingGroup),
    );
  }

  private isBenchmarkFilterManager(): boolean {
    return this.extendedTypeId === ExtendedOrderTypeIdentifier.BENCHMARK;
  }

  private isInterventionFilterManager(): boolean {
    return this.blotterTypeId.blotterType === CubiqTS.BlotterType.INTERVENTION;
  }

  public sayHello() {
    logger.out.info("hello world");
  }

  public processCalendarValue(
    $event: any,
    data: BfxBlotterFilterCondition,
    dateTo: boolean = false,
  ): void {
    if (data != null) {
      let formatter: any = (value) => {
        return value ? value : "";
      };
      let columnDef: BfxColDef = this.columns[data.conditionData.value] as BfxColDef;
      // define formatter
      if (columnDef.columnFilterType == ColumnFilterType.DATE) {
        formatter = ($eventValue) => {
          let dateValue = new Date($eventValue.toString());
          dateValue.setHours(0, 0, 0, 0);
          let timezoneOffset = dateValue.getTimezoneOffset() * 60000;
          return (dateValue.getTime() - timezoneOffset).toString();
        };
      } else if (columnDef.columnFilterType == ColumnFilterType.DATETIME) {
        formatter = ($eventValue) => {
          let dateValue = new Date($eventValue.toString());
          let timezoneOffset = dateValue.getTimezoneOffset() * 60000;
          return (dateValue.getTime() - timezoneOffset).toString();
        };
      } else if (columnDef.columnFilterType == ColumnFilterType.TIME) {
        // not in use atm
        formatter = ($eventValue) => {
          return $eventValue.toString();
        };
      }
      // assign value
      if (this.blotterService.betweenOperators[data.operatorData.value]) {
        // It's a Between
        if (dateTo) {
          data.to = formatter($event);
        } else {
          data.from = formatter($event);
        }
      } else {
        // It's NOT a Between
        data.value = formatter($event);
      }
    }
  }
}
